// https://www.npmjs.com/package/vue-unique-id
import Vue from 'vue';
import UniqueId from 'vue-unique-id';

Vue.use(UniqueId);
